import * as React from 'react';
import { Select } from '@moovly/ui';
import { getEventTypesSelect } from '../../configs/events';
import { t } from '@moovly/i18n';
import './LogsFilter.scss';

export type FilterOption = {
  value: string;
  label: string;
};

interface LogsFilterProps {
  selectedTypes: string[];
  onSelectTypes: (types: string[]) => void;
  groupOptions: { value: string; label: string }[];
  onGroupChange: (groupId: string) => void;
  selectedGroup?: string;
}

const LogsFilter: React.FC<LogsFilterProps> = ({
  selectedTypes,
  onSelectTypes,
  groupOptions,
  onGroupChange,
  selectedGroup,
}) => {
  const handleChange = React.useCallback(
    (options: FilterOption[]) => onSelectTypes(options.map((option) => option.value)),
    [onSelectTypes]
  );
  const handleGroupChange = React.useCallback(({ value }: FilterOption) => onGroupChange(value), [onGroupChange]);
  const selectedEventTypes = React.useMemo(
    () => getEventTypesSelect().filter((type) => selectedTypes.includes(type.value)),
    [selectedTypes]
  );
  const eventTypeOptions = React.useMemo(getEventTypesSelect, []);
  const showGroupsSelect = React.useMemo(() => groupOptions.length > 1, [groupOptions]);
  return (
    <div className="FilterWrapper mb-4">
      <div className="row">
        <div className={showGroupsSelect ? 'col-md-8' : 'col-md-12'}>
          <div className="d-flex align-items-center ">
            <label htmlFor="logsTypeSelect" className="form-label m-1 me-2">
              {t(`statistics.events.headers.type`)}
            </label>
            <div className="child-no-margin  w-100">
              <Select
                className="m-0"
                id="logsTypeSelect"
                value={selectedEventTypes}
                // @ts-ignore
                isMulti
                onChange={handleChange}
                options={eventTypeOptions}
              />
            </div>
          </div>
        </div>
        {showGroupsSelect && (
          <div className="col-md-4">
            <div className="d-flex align-items-center">
              <label htmlFor="logsTypeSelect" className="form-label m-1 me-3">
                {t(`statistics.events.headers.group`)}
              </label>
              <div className="child-no-margin w-100">
                <Select
                  id="logsTypeSelect"
                  value={groupOptions.find((gr) => gr.value === selectedGroup)}
                  onChange={handleGroupChange}
                  options={groupOptions}
                />
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default LogsFilter;
